<template>
  <v-row class="ma-0">
    <v-col cols="12" class="pa-0">
      <div class="plan-title-wrap">
        <span class="plan-title"
          >연차계획 {{ planCount }}
          <span class="divider point-blue">{{ planObj.closeDay }}일</span></span
        >
        <v-btn
          class="ml-auto"
          color="#e0e3e5"
          elevation="0"
          width="38"
          min-width="38"
          height="38"
          @click="$emit('deletePlan', planObj, index)"
        >
          <v-icon size="18">mdi-delete-outline</v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12" class="pt-4 pb-2 px-6 bb-line borderLine-outer">
      <div class="borderLine-wrap">
        <span class="plan-title label-width">근태종류</span>
        <span class="plan-desc">{{ planObj.codeObj.codeNm }}</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="$emit('showList', index)"
        >
          <v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div class="py-3 inner-wrap">
        <span class="plan-title label-width">사용일</span>
        <span class="plan-desc">{{ planObj.date }}</span>
        <v-btn
          elevation="0"
          color="#f4f5f5"
          class="ml-auto"
          @click="$emit('showDate', index)"
          >날짜선택</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    planObj: Object,
    index: Number,
  },
  computed: {
    planCount() {
      const index = this.index + 1;
      return index < 10 ? '0' + index : index;
    },
  },
};
</script>

<style>
.inner-wrap {
  display: flex;
  align-items: center;
}
</style>
